const SIGNUP_INTENT_KEY = 'volyx_volunteer_oauth_signup';
const OAUTH_NEXT_KEY = 'volyx_oauth_redirect_next';
/** Set when UserContext blocks signup OAuth so AuthCallback can show duplicate UI after sign-out. */
export const OAUTH_DUPLICATE_UI_KEY = 'volyx_oauth_duplicate_ui';

function storage(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

/** Call immediately before starting volunteer signup OAuth. */
export function markVolunteerOAuthSignupIntent(): void {
  const s = storage();
  if (!s) return;
  try {
    s.setItem(SIGNUP_INTENT_KEY, '1');
    s.setItem(OAUTH_NEXT_KEY, '/onboarding');
  } catch {
    // quota / private mode
  }
}

export function peekVolunteerOAuthSignupIntent(): boolean {
  const s = storage();
  if (!s) return false;
  try {
    return s.getItem(SIGNUP_INTENT_KEY) === '1';
  } catch {
    return false;
  }
}

export function getVolunteerOAuthStoredNext(): string | null {
  const s = storage();
  if (!s) return null;
  try {
    const n = s.getItem(OAUTH_NEXT_KEY);
    return n && n.startsWith('/') && !n.startsWith('//') ? n : null;
  } catch {
    return null;
  }
}

export function clearVolunteerOAuthSignupIntent(): void {
  const s = storage();
  if (!s) return;
  try {
    s.removeItem(SIGNUP_INTENT_KEY);
    s.removeItem(OAUTH_NEXT_KEY);
  } catch {
    // ignore
  }
}

export function markOAuthDuplicateUiPending(): void {
  const s = storage();
  if (!s) return;
  try {
    s.setItem(OAUTH_DUPLICATE_UI_KEY, '1');
  } catch {
    // ignore
  }
}

export function consumeOAuthDuplicateUiPending(): boolean {
  const s = storage();
  if (!s) return false;
  try {
    const pending = s.getItem(OAUTH_DUPLICATE_UI_KEY) === '1';
    if (pending) s.removeItem(OAUTH_DUPLICATE_UI_KEY);
    return pending;
  } catch {
    return false;
  }
}
